// 税务项目列表表头
export let taxationTableLabel = [
  {
    label: '项目名称',
    value: 'xmmc'
  },
  {
    label: '税率',
    value: 'rate'
  },
  {
    label: '单位',
    value: 'dw'
  },
  {
    label: '项目编码',
    value: 'xmbm'
  }
]
